import { Input, List, notification } from 'antd';
import React from 'react';

export const filterOption = (value, option, minLength = 3) =>
  value.length >= minLength &&
  option.toLowerCase().indexOf(value.toLowerCase()) >= 0;

export const filterAllOption = (value, option = '') => {
  if (/[!@#$%^&*(),.?":{}|<>]/g.test(value)) return filterOption(value, option);

  const parsed = option
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
    .toLowerCase();
  return parsed.search(value.toLowerCase()) >= 0;
};

export const showErrors = (
  message = 'Ops, algo deu errado',
  errors = ['Caso o problema persista, entre em contato com nosso suporte.']
) =>
  notification.warning({
    message,
    description: (
      <List
        itemLayout="horizontal"
        dataSource={errors}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta description={<strong>{item}</strong>} />
          </List.Item>
        )}
      />
    ),
  });

export const percentageConfig = {
  customInput: Input,
  thousandSeparator: '.',
  decimalSeparator: ',',
  suffix: ' %',
  allowLeadingZeros: true,
  placeholder: '0%',
};

export const moneyConfig = {
  customInput: Input,
  thousandSeparator: '.',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: true,
  prefix: 'R$ ',
  placeholder: 'R$',
  allowNegative: false,
  isAllowed: values => values.floatValue >= 1,
};

export const tonConfig = {
  customInput: Input,
  thousandSeparator: '.',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: true,
  allowNegative: false,
  isAllowed: values => values.floatValue >= 0.01,
};

export const novaMoneyConfig = {
  customInput: Input,
  thousandSeparator: '.',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: true,
  prefix: 'R$ ',
  placeholder: 'R$',
  allowNegative: false,
};

const MAX_VAL = 1000000;
const withValueCap = inputObj => {
  const { value } = inputObj;
  if (value <= MAX_VAL) return true;
  return false;
};

export const configTonelada = {
  customInput: Input,
  thousandSeparator: '.',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: true,
  allowNegative: false,
  isAllowed: withValueCap,
};

export const intConfig = {
  customInput: Input,
  decimalScale: 0,
  allowNegative: false,
};
